/**
 * H5Guard 配置和工具函数
 * 用于请求签名和安全验证
 */

import { sendRaptorErr } from './util'

export function initH5Guard() {
  if (!window.H5guard) {
    console.warn('⚠️ [H5Guard] H5Guard SDK 未加载')
    return false
  }

  try {
    window.H5guard.init({
      domains: [
        'quickpass.meituan.com',
        'quickpass.cx.st.sankuai.com',
        'quickpass.cx.test.sankuai.com',
      ],
    })
    console.log('✅ [H5Guard] 初始化成功')
    return true
  } catch (error) {
    console.error('❌ [H5Guard] 初始化失败:', error)
    sendRaptorErr('H5Guard初始化失败', error, 'customError')
    return false
  }
}

export function onH5GuardReady(callback) {
  if (!window.H5guard) {
    console.warn('⚠️ [H5Guard] H5Guard SDK 未加载')
    return
  }

  if (typeof callback === 'function') {
    console.log('onH5GuardReady, 准备回调callback')
    if (window.H5guard && window.H5guard.init) {
      console.log('回调callback')
      callback()
    } else {
      console.log('延时开始')
      const checkInterval = setInterval(() => {
        if (window.H5guard && window.H5guard.init) {
          clearInterval(checkInterval)
          callback()
        }
      }, 100)

      setTimeout(() => {
        clearInterval(checkInterval)
      }, 5000)
    }
  } else {
    console.warn('没找到H5guard对象')
  }
}

export default {
  initH5Guard,
  onH5GuardReady,
}
